var indentStyle = {"indentZero":"-MlB1","indentOne":"_3oS9Q","indentTwo":"_1YqGv","indentThree":"JFJgf","indentFour":"CT85e","indentFive":"jNRnu","indentSix":"_58SxQ"};

export { indentStyle as i };
//# sourceMappingURL=indentation-cf1bb853.js.map
